/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteQuoteRequest
 */
export interface DeleteQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteQuoteRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the DeleteQuoteRequest interface.
 */
export function instanceOfDeleteQuoteRequest(value: object): value is DeleteQuoteRequest {
    return true;
}

export function DeleteQuoteRequestFromJSON(json: any): DeleteQuoteRequest {
    return DeleteQuoteRequestFromJSONTyped(json, false);
}

export function DeleteQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function DeleteQuoteRequestToJSON(value?: DeleteQuoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

